import { PRODUCT_SAVINGS_ACCOUNTS } from '@/constants/products';
import { getRateChanges } from '@/graphql/queries/shared/rate-change';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getRateChanges, { product: PRODUCT_SAVINGS_ACCOUNTS }).then(r => {
    const description = store.$i18n.t('rate-changes.description');
    const subtitle = store.$i18n.t('rate-changes.subtitle');
    const title = store.$i18n.t('rate-changes.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('rateChanges/setMeta', r.data);
    store.commit('rateChanges/set', r.changes);
    store.commit('utils/setPagination', r.meta.pagination);
  });
};
